/*
 * @Author: your name
 * @Date: 2020-10-19 18:03:50
 * @LastEditTime: 2020-11-10 11:16:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-consumer-platform/src/utils/webSocket/wsBase.js
 */
import Sleep from '../sleep';
export default function () {
  let pool = {},
      // 连接池对象
  poolSize = 0,
      // 连接池大小
  connects = [],
      // 连接数组
  size,
      // 传入的大小
  url,
      // 地址
  reConnectTime = 0; // 重连次数
  // 建立websocket连接方法

  function createConnect(url, callBack) {
    // console.log('installinstallinstallinstallinstall', url)
    let webSocket = new WebSocket(url); // 创建链接
    // webSocket连接之后的操作

    webSocket.onopen = event => onOpen(pool, event);

    function onOpen(pool, event) {
      // console.log('onOpenonOpenonOpenonOpenonOpenonOpenonOpenonOpen')
      connects.push(webSocket);
      poolSize = connects.length; // 控制发链接

      pool.onOpen && pool.onOpen(event);
      callBack && connects.length === size && callBack.resolve(true);
    } // webSocket接收信息的操作


    webSocket.onmessage = event => onMessage(pool, event);

    function onMessage(pool, event) {
      pool.onMessage && pool.onMessage(event.data);
    } // webSocket断开之后的操作


    webSocket.onclose = onClose;

    async function onClose(event) {
      console.log('onCloseonCloseonCloseonCloseonCloseonClose', webSocket.readyState);
      pool.onClose && pool.onClose(event);

      if (reConnectTime > 10) {
        pool.close();
        reConnectTime = 0;
        return;
      } // await Sleep(2000 * (reConnectTime + 1));


      await Sleep(2000);
      reConnect(webSocket, callBack);
    } // webSocket出错之后的操作


    webSocket.onerror = onError;

    async function onError(event) {
      console.log('onErroronErroronErroronErroronError');
      pool.onError && pool.onError(event);

      if (reConnectTime > 10) {
        pool.close();
        reConnectTime = 0;
        return;
      } // await Sleep(2000 * (reConnectTime + 1));


      await Sleep(2000);
      reConnect(webSocket, callBack);
    }
  }

  function reConnect(webSocket, callBack) {
    if (webSocket.hadRemoved) {
      return;
    }

    reConnectTime++;
    let index = connects.indexOf(webSocket);

    if (index >= 0) {
      connects.splice(index, 1);
    }

    webSocket.hadRemoved = true;
    console.log('reConnectreConnectreConnectreConnectreConnectreConnect', connects.length < size && pool.reConnectFlag, index);
    connects.length < size && pool.reConnectFlag && createConnect(url, callBack);
  }

  pool.start = function (_url, _size) {
    url = _url;
    size = _size;
    pool.reConnectFlag = true; // 控制是否开启重连，主动断开不开启重连
    // console.log('startstartstartstartstartstartstartstartstart', _url, _size)

    return new Promise((resolve, reject) => {
      const callBack = {
        size,
        resolve,
        reject
      };

      for (let i = 0; i < size; i++) createConnect(url, callBack);
    });
  }; // 发送信息调用函数


  let index = 0;

  pool.send = function (text) {
    if (connects.length === 0) console.log('==connect is all down!===');
    poolSize && connects[index++ % poolSize] && connects[index++ % poolSize].send(text);
  }; // 关闭链接


  pool.close = function () {
    if (connects.length === 0) console.log('==connect is all down!===');
    pool.reConnectFlag = false;
    poolSize && connects && connects.forEach(v => v.close());
  };

  return pool;
}